module.exports = __webpack_public_path__ + "static/img/wealth_level_97.a08a614.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_97.png
// module id = a51m
// module chunks = 0